// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MrMUPSysc0qjxr {
  font-weight: var(--ds-font-weight-bold, bold);
}
.E5YG4KRdnRRVCY {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortcodes": `MrMUPSysc0qjxr`,
	"name": `E5YG4KRdnRRVCY`
};
export default ___CSS_LOADER_EXPORT___;
